import { createApiClient } from "./apiClientFactory";
import { EnvironmentService } from "@/utils/environment";

export const useEdgeApi = (community?: string) => {
    // If no community is provided, extract it from the hostname
    if (!community) {
        community = EnvironmentService.getCommunity() || "consumer";
    }

    return createApiClient("edge", community);
};
